import axios from 'axios';

export default async function CheckCookie (data, onSuccess, onError){
    try{
        const response = await axios.get("/user/me", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            // baseURL: "https://shielded-lowlands-66092.herokuapp.com/"
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        console.log(response.data.status);
        onSuccess && onSuccess(response);
    }
    catch(error){
        console.log(error);
        onError && onError(error);
    }
}